import { DropdownMenu, useDropdownDirection } from '@consigli/facade';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusDropdownContent } from './status-dropdown-content';

interface BulkUpdateStatusPopoverProps {
  isOpen: boolean;
  onSelect: (status: string) => void;
}

/**
 * Bulk status popover that reuses StatusDropdownContent for consistency.
 * Renders the same status dropdown as EditableStatus but in a bulk context.
 */
export const BulkUpdateStatusPopover: FC<BulkUpdateStatusPopoverProps> = ({ isOpen, onSelect }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  const openDirection = useDropdownDirection({
    containerRef,
    isOpen,
    dropdownHeight: 250,
  });

  return (
    <div className="relative" ref={containerRef}>
      <DropdownMenu
        isOpen={isOpen}
        direction={openDirection}
        header={t('meeting-secretary.action-items.update-status')}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
        onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
      >
        <StatusDropdownContent onSelect={onSelect} />
      </DropdownMenu>
    </div>
  );
};
